import React, { useEffect } from "react";
import { useForm, useFieldArray } from "react-hook-form";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrash } from "@fortawesome/free-solid-svg-icons";
import { updatepackagecancellationmethods } from "../axios";
import { getPenalty, addDayAvail } from "./filedata";

const CancellationForm = (props) => {
  const {
    control,
    register,
    handleSubmit,
    setValue,
    trigger,
    watch,
    formState: { errors },
  } = useForm({
    defaultValues: {
      package_cancellation: [{ day_before: "", penalty: "", amount: "" }],
      policies: "",
    },
  });

  const { fields, append, remove } = useFieldArray({
    control,
    name: "package_cancellation",
  });

  useEffect(() => {
    if (
      props?.cancellation?.cancellation_policy !== "no_cancellationPolicy" &&
      props?.cancellation?.cancellation_policy?.length > 0
    ) {
      const cancellationPolicies = props.cancellation.cancellation_policy[0];
      setValue(
        "package_cancellation",
        cancellationPolicies.map((policy) => ({
          day_before: policy?.day_before_arrival,
          penalty: policy?.cancellation_penalty_id,
          amount: policy?.cancellation_value,
        }))
      );
    }
    setValue("policies", props?.policies);
  }, [props.packageID, props.cancellation?.cancellation_policy, setValue]);

  const handleAddRow = async () => {
    const lastIndex = fields.length - 1;
    const lastField = watch(`package_cancellation[${lastIndex}]`);

    if (lastField?.day_before) {
      append({ day_before: "", penalty: "", amount: "" });
    } else {
      trigger(`package_cancellation[${lastIndex}].day_before`);
    }
  };

  const onSubmit = async (data) => {
    try {
      const { package_cancellation, policies } = data;
      await updatepackagecancellationmethods(props.packageID, policies, package_cancellation)
      alert("Policy updated successfully.");
    } catch (error) {
      console.error("Error updating package price:", error);
      alert("Error updating package price. Please try again.");
    }
  };

  const isAmountDisabled = (penalty) => penalty === "1" || penalty === "2";

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <div className="col-lg-12">
        <div className="card">
          <div className="card-body">
            <div className="row">
              <div className="form-group col-lg-3">Days Before Arrival</div>
              <div className="form-group col-lg-3">Penalty</div>
              <div className="form-group col-lg-4">Amount</div>
              <div className="form-group col-lg-2">Delete</div>
            </div>

            {fields.map((field, index) => (
              <div className="row" key={field.id}>
                <div className="form-group col-lg-3">
                  <select
                    className="form-control"
                    {...register(`package_cancellation.${index}.day_before`, {
                      required: "This field is required",
                    })}
                  >
                    <option value="">Select Days</option>
                    {addDayAvail.map((option) => (
                      <option key={option.id} value={option.id}>
                        {option.value}
                      </option>
                    ))}
                  </select>
                  {errors.package_cancellation?.[index]?.day_before && (
                    <div className="text-danger">
                      {errors.package_cancellation[index].day_before.message}
                    </div>
                  )}
                </div>

                <div className="form-group col-lg-3">
                  <select
                    className="form-control"
                    {...register(`package_cancellation.${index}.penalty`, {
                      required: "This field is required",
                    })}
                    onChange={(e) => {
                      const penaltyValue = e.target.value;
                      setValue(`package_cancellation.${index}.penalty`, penaltyValue);

                      if (isAmountDisabled(penaltyValue)) {
                        setValue(`package_cancellation.${index}.amount`, "");
                      }
                    }}
                  >
                    <option value="">Select Penalty</option>
                    {getPenalty.map((option) => (
                      <option key={option.id} value={option.id}>
                        {option.value}
                      </option>
                    ))}
                  </select>
                  {errors.package_cancellation?.[index]?.penalty && (
                    <div className="text-danger">
                      {errors.package_cancellation[index].penalty.message}
                    </div>
                  )}
                </div>

                <div className="form-group col-lg-4">
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Amount"
                    {...register(`package_cancellation.${index}.amount`, {
                      required: isAmountDisabled(watch(`package_cancellation.${index}.penalty`))
                        ? false
                        : "Amount is required",
                    })}
                    disabled={isAmountDisabled(watch(`package_cancellation.${index}.penalty`))}
                  />
                  {errors.package_cancellation?.[index]?.amount && (
                    <div className="text-danger">
                      {errors.package_cancellation[index].amount.message}
                    </div>
                  )}
                </div>

                {fields.length > 1 && (
                  <div className="form-group col-lg-2">
                    <FontAwesomeIcon
                      icon={faTrash}
                      style={{
                        fontSize: "14px",
                        marginRight: "5px",
                        cursor: "pointer",
                        marginTop: "10px",
                        color: "#a8a8a8",
                      }}
                      onClick={() => remove(index)}
                    />
                  </div>
                )}
              </div>
            ))}

            <div className="row">
              <div className="form-group col-lg-12">
                <button type="button" className="btn btn-primary" onClick={handleAddRow}>
                  Add Rule
                </button>
              </div>
            </div>

            <div className="row">
              <div className="form-group col-lg-12">
                <label htmlFor="exampleInputEmail1" className="form-label">
                  Other policies
                </label>
                <textarea
                  className="form-control"
                  rows="6"
                  placeholder="Other policies..."
                  {...register("policies")}
                ></textarea>
              </div>
            </div>

            <div className="col-lg-12 mt-3">
              <button type="submit" className="btn btn-success">
                Submit
              </button>
            </div>
          </div>
        </div>
      </div>
    </form>
  );
};

export default CancellationForm;
